import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldCheck, Loader2, XCircle } from "lucide-react";

export default function KycComplete() {
  const [sp] = useSearchParams();
  const requestId = sp.get("id") || sp.get("request_id") || "";
  const [state, setState] = useState({ status: "checking", verified: false });

  useEffect(() => {
    if (!requestId) return;
    let stop = false;
    const tick = async () => {
      try {
        const { data } = await api.get(`/kyc/${requestId}/status`);
        if (stop) return;
        setState({ status: data.status, verified: data.verified });
        if (!data.verified) setTimeout(tick, 4000);
      } catch (e) {
        toast.error(formatError(e));
      }
    };
    tick();
    return () => { stop = true; };
  }, [requestId]);

  return (
    <div className="max-w-md mx-auto px-6 py-16 text-center">
      <div className="p-10 border" style={{ borderRadius: 8, borderColor: "var(--umg-border)", background: "var(--umg-surface)" }}>
        {state.verified ? (
          <>
            <ShieldCheck className="w-16 h-16 text-[#4F7942] mx-auto" strokeWidth={1.5} />
            <h2 className="font-display text-3xl mt-4">KYC Verified</h2>
            <p className="mt-3 text-sm text-[color:var(--umg-text-2)]">You now carry the Umaang Verified badge.</p>
            <Link to="/home" className="mt-6 inline-block">
              <Button className="btn-pill bg-[#C85A53] hover:bg-[#A94842] text-white">Go to Umaang</Button>
            </Link>
          </>
        ) : state.status === "checking" ? (
          <>
            <Loader2 className="w-12 h-12 text-[#C85A53] mx-auto animate-spin" />
            <h2 className="font-display text-2xl mt-4">Checking verification…</h2>
            <p className="mt-3 text-sm text-[color:var(--umg-text-2)]">This may take a few seconds.</p>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 text-[color:var(--umg-text-2)] mx-auto" />
            <h2 className="font-display text-2xl mt-4">Pending — status: {state.status}</h2>
            <p className="mt-3 text-sm text-[color:var(--umg-text-2)]">
              Please wait, we'll auto-refresh. Or you can complete the DigiLocker consent flow if it hasn't completed.
            </p>
            <Link to="/profile/edit" className="mt-6 inline-block text-[#C85A53] underline text-sm">
              Back to profile
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
